import { render, staticRenderFns } from "./LightRGB.vue?vue&type=template&id=1e143fd2&scoped=true&"
import script from "./LightRGB.vue?vue&type=script&lang=ts&"
export * from "./LightRGB.vue?vue&type=script&lang=ts&"
import style0 from "./LightRGB.vue?vue&type=style&index=0&id=1e143fd2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e143fd2",
  null
  
)

export default component.exports